import './App.css';
import * as AuthAPI from './services/authAPI';
import AuthContext from './context/AuthContext';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SetPasswordPage from './pages/SetPasswordPage';
import { useState } from 'react';
import UsersPage from './pages/UsersPage';
import UserPage from './pages/UserPage';
import TicketsPage from './pages/TicketsPage';
import TicketPage from './pages/TicketPage';
import VehiclesPage from './pages/VehiclesPage';
import VehiclePage from './pages/VehiclePage';
import Sidebar from './components/Sidebar';
import DashboardPage from './pages/DashboardPage';
import HelpPage from './pages/HelpPage';
import Page404 from './pages/Page404';

function App() {

    const navigate = useNavigate();

    const [isAuthenticated, setIsAuthenticated] = useState(AuthAPI.isAuthenticated());

    const user = AuthAPI.setup();
    const firstName = user?.firstName;
    const lastName = user?.lastName;
    const role = user?.role;

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            setIsAuthenticated
        }}>
            <div className="App">
                <div className="d-flex">
                {isAuthenticated && <Sidebar
                    navigate={navigate}
                    firstName={firstName}
                    lastName={lastName}
                    role={role}
                />}
                <div className={`main-content flex-grow-1 ${isAuthenticated ? 'with-sidebar' : ''}`}>
                    <div className="container-fluid p-4">
                        <Routes>
                <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <LoginPage navigate={navigate} />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage navigate={navigate} />} />
                <Route path="/reset-password" element={<SetPasswordPage navigate={navigate} mode="reset" />} />
                <Route path="/register" element={<SetPasswordPage navigate={navigate} mode="invitation" />} />
                <Route element={<PrivateRoute />}>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/users/:id" element={<UserPage />} />
                    <Route path="/tickets" element={<TicketsPage />} />
                    <Route path="/tickets/:id" element={<TicketPage />} />
                    <Route path="/vehicles" element={<VehiclesPage />} />
                    <Route path="/vehicles/:id" element={<VehiclePage />} />
                    <Route path="/help" element={<HelpPage />} />
                </Route>
                <Route path="*" element={<Page404 />} />
            </Routes>
                    </div>
                </div>
                </div>
            </div>
        </AuthContext.Provider>
    )
}

export default App;
